$(document).on('click', '.filter__item__label', function() {
    const checkbox = $(this).prev();
    checkbox[0].checked = !checkbox[0].checked;
});
